const commonConfig = {
  TRONGRID_API_KEY: process.env.TRONGRID_API_KEY,
};

const devConfig = {
  API_URL: "http://localhost:3000",
  BASE_NET: "_TESTNET_",
  SENTRY_DSN:
    "https://6680af16eb5c87648c0947e56d45ccc9@o4506939352219648.ingest.us.sentry.io/4507941184471040",
  EXPO_PUBLIC_SENTRY_ENVIRONMENT: process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT,
  SENTRY_SAMPLE_RATE: 0,
  ...commonConfig,
};

const productionConfig = {
  API_URL: "https://izziwallet.io/api",
  BASE_NET: "_MAINNET_",
  SENTRY_DSN:
    "https://6680af16eb5c87648c0947e56d45ccc9@o4506939352219648.ingest.us.sentry.io/4507941184471040",
  EXPO_PUBLIC_SENTRY_ENVIRONMENT: process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT,
  SENTRY_SAMPLE_RATE: 1,
  ...commonConfig,
};

export const envConfig = __DEV__
  ? devConfig
  : process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT === "PRODUCTION"
    ? productionConfig
    : devConfig;
